<template>
    <div>
        <div class="main-body desktop">
            <div class="circles">
                <div class="big-circle"></div>
                <div class="medium-circle"></div>
                <div class="small-circle"></div>
            </div>
           <div class="site-header">
                <router-link class="brand p-2" to="/">
                    <img class="logo-img" :src="logo.src" alt="" />
                </router-link>
            </div>
            <b-row>
                <b-col cols="6"></b-col>
                <b-col cols="6" class="form-box">
                    <p>Password Reset</p>
                    <p>Please input a new password and PIN</p>
                    <form @submit.prevent="submit" class="form-container">
                        <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="lock"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input :state="$v.token.required" v-model.trim="$v.token.$model" v-model="token"
                                    type="number" placeholder="4 digit PIN"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="lock"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input :state="$v.password.required" v-model.trim="$v.password.$model"
                                    v-model="password" type="password" placeholder="Password"></b-form-input>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="!$v.password.minLength">Minimum
                                {{ $v.password.$params.minLength.min }} characters.</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group class="col-md-12 mt-4 " label-for="input-1">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="lock"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input v-model="password_confirmation" type="password"
                                    placeholder="Confirm Password"></b-form-input>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="!$v.password_confirmation.sameAsPassword">Passwords must be
                                identical.</b-form-invalid-feedback>

                        </b-form-group>

                        <b-form-group class="col-md-12 button-contain mb-3" label-for="input-1">
                            <button class="btn btn-warning">{{resetTxt}}
                                <font-awesome-icon :icon="['fas', 'arrow-right']" />
                            </button>
                        </b-form-group>
                        <p>
                            <router-link to="/accounts/signin">Login</router-link> or <router-link
                                to="/accounts/signup">Signup</router-link>
                        </p>
                    </form>
                </b-col>
            </b-row>
            <div class="foot-text">
                <p>Welcome to Culture Square</p>
                <ul class="ml-2">
                    <li>Sell</li>
                    <li>Buy</li>
                    <li>Host Events</li>
                    <li>Attend Events</li>
                </ul>
            </div>

        </div>
        <div class="mobile">
            <AbstractHeader />
            <div class="form-box">
                <p>Password Reset</p>
                <p>Please input a new password and PIN</p>
                <form @submit.prevent="submit" class="form-container">
                    <b-form-group class="col-md-12 mt-4 mb-3" label-for="input-1">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input :state="$v.token.required" v-model.trim="$v.token.$model" v-model="token"
                                type="number" placeholder="4 digit PIN"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-12 mt-4 mb-3" label-for="password">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input :state="$v.password.required" v-model.trim="$v.password.$model"
                                v-model="password" type="password" placeholder="Password"></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback v-if="!$v.password.minLength">Minimum
                            {{ $v.password.$params.minLength.min }} characters.</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group class="col-md-12 mt-4 " label-for="password_confirmation">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="lock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model="password_confirmation" type="password"
                                placeholder="Confirm Password"></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback v-if="!$v.password_confirmation.sameAsPassword">Passwords must be
                            identical.</b-form-invalid-feedback>

                    </b-form-group>

                    <b-form-group class="col-md-12 button-contain mb-3" label-for="input-1">
                        <button class="btn btn-warning">{{resetTxt}}
                            <font-awesome-icon :icon="['fas', 'arrow-right']" />
                        </button>
                    </b-form-group>
                    <p class="ml-3">
                        <router-link to="/accounts/signin">Login</router-link> or <router-link to="/accounts/signup">
                            Signup</router-link>
                    </p>
                </form>
            </div>

        </div>
    </div>
</template>

<script>
import AbstractHeader from "@/components/AbstractHeader.vue";
import { getLogoUrl } from "../../../utils/common";
import {
    required,
    sameAs,
    minLength,
} from "vuelidate/lib/validators";
import {
    getBaseUrl
} from "../../../utils/common";
import axios from "axios";
const base_url = getBaseUrl();
export default {
    name: 'change-password',
    data: function () {
        return {
            password: "",
            password_confirmation: "",
            email: this.$route.params.email,
            loading: false,
            token:'',
            resetTxt: "Reset Password",
            logo: {}
        }
    },
    validations: {
        password: {
            required,
            minLength: minLength(8)
        },
        token: {
            required
        },
        password_confirmation: {
            sameAsPassword: sameAs("password")
        }
    },
    components: {
        AbstractHeader
    },
    created() {
        this.logo = getLogoUrl(); // Generate the logo object
    },
    methods: {
        resetFields() {
            this.resetForm.email = '';
            this.resetForm.password = '';
            this.resetForm.password_confirmation = '';
        },
        async submit() {
            this.resetTxt = "Resetting...";
            this.loading = true;
            try {
                const email = this.email;
                const resp = await axios.post(`${base_url}/api/v2/auth/password/reset?email=${email}`, {
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    token: this.token
                })
                this.loading = false;
                this.resetTxt = "Reset Password";
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.$router.push("/accounts/signin");
            } catch (error) {
                this.loading = false;
                this.resetTxt = "Reset Password"
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.main-body {
    height: 100vh;
    background-image: url('../../assets/images/abstract.svg');
    background-repeat: no-repeat;
}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;
}

.site-header {
    padding: 30px 50px;
}

.logo-img {
    position: fixed;
    width: 8%
}

.circles {
    position: absolute
}

.big-circle {
    position: relative;
    left: 191%;
    top: -58px;
    height: 190px;
    width: 190px;
    border-radius: 50%;
    background: #F7B131;
}

.medium-circle {
    position: relative;
    left: 295%;
    top: -90px;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background: #F7B131;
}

.small-circle {
    position: relative;
    left: 300%;
    top: -50px;
    height: 62px;
    width: 62px;
    border-radius: 50%;
    background: #F7B131;
}

.form-container {
    background: none;
    box-shadow: none;
    padding: 30px 15px 15px 0px !important;
}

a {
    color: #F7B131;
}

.form-box {
    padding: 40px 75px 50px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 40px 20px 20px 20px;
    }
}

.form-box p:first-child {
    font-size: 28px;
    border-bottom: 1px solid #E0E0E0;
}

.foot-text {
    color: #fff;
    position: fixed;
    bottom: 0;
    padding-bottom: 1rem
}

.foot-text p {
    padding-left: 2.5rem;
    font-size: 14px
}

.foot-text ul {
    display: flex
}

.foot-text ul>li {
    margin: 0 10px;
}

.button-contain {
    margin-top: 40px;

}

.button-contain button {
    width: 100%
}

.svg-inline--fa {
    height: 0.7em !important
}

@media screen and (min-width: 1400px) {
    .big-circle {
        position: relative;
        left: 191%;
        top: -58px;
        height: 211px;
        width: 211px;
        border-radius: 50%;
        background: #F7B131;
    }

    .medium-circle {
        position: relative;
        left: 285%;
        top: -90px;
        height: 129px;
        width: 129px;
        border-radius: 50%;
        background: #F7B131;
    }

    .small-circle {
        position: relative;
        left: 280%;
        top: -50px;
        height: 62px;
        width: 62px;
        border-radius: 50%;
        background: #F7B131;
    }
}
</style>
